import {datasourcestore, EntityID, RestDataSource} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";
import {IfwEntity} from "./AbstractEntity.js";

type CustomFieldType = "text" | "checkbox" | "date" | "select" | "number";

export interface CustomFieldEntity extends IfwEntity {
	options: { [p: string]: any }[];
	data: {
		maxLength: number,
		multiline: boolean,
		withTime: boolean,
		options: string[]
	},
	fieldSetId: EntityID,
	sortOrder: number,
	type: CustomFieldType,
	hintText: string,
	name: string,
	databaseName: string,
	placeholder?: string,
	required: boolean,
	defaultValue: string,
	deleted: boolean,
	filterable: boolean
}

export interface CustomFieldSetEntity extends IfwEntity {
	sortOrder: number,
	modelName: string,
	name: string,
	displayFrontend: boolean,
	readOnlyFrontend: boolean,
	deleted: boolean,
	fields: CustomFieldEntity[]
}


// TODO: PHP module class, e.g. GO\Modules\Instructiefilm\Elearning\Model\ParticipantCustomFields
// TODO: other GET variables? YAGNI?
const pu = "customfields/fieldsets/" + encodeURIComponent("GO\\Modules\\Instructiefilm\\Elearning\\Model\\ParticipantCustomFields");
export const customFieldSetsDS = new RestDataSource<CustomFieldSetEntity>(ServerApi.url(pu, {
	returnProperties: '*,fields',
	limit: 0
}, true), "participantCustomFields");

export const customFieldsStore = datasourcestore({
	dataSource: customFieldSetsDS
});